import React, { useState, useEffect } from 'react';
import { User } from '../../types/auth';
import authService from '../../services/authService';
import { phoneMask, removePhoneMask } from '../../utils/masks';

interface CompleteProfileProps {
  onComplete: (user: User) => void;
}

const CompleteProfile: React.FC<CompleteProfileProps> = ({ onComplete }) => {
  const [telefone, setTelefone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    
    if (token) {
      authService.setToken(token);
    } else {
      window.location.href = '/login?error=no_token';
    }
  }, []);

  const handleTelefoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const masked = phoneMask(e.target.value);
    setTelefone(masked);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!telefone.trim()) {
      setError('Telefone é obrigatório');
      return;
    }

    const cleanPhone = removePhoneMask(telefone);
    if (cleanPhone.length < 10) {
      setError('Telefone deve ter pelo menos 10 dígitos');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await authService.updateProfile(undefined, cleanPhone);
      const userData = await authService.getProfile();
      onComplete(userData);
    } catch (error: any) {
      setError(error.message || 'Erro ao atualizar perfil');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center" style={{height: '100vh', backgroundColor: '#f8f9fa'}}>
      <div className="card shadow-lg" style={{width: '400px'}}>
        <div className="card-body p-4">
          <div className="text-center mb-4">
            <h3 className="text-success mb-2">Complete seu Perfil</h3>
            <p className="text-muted">Para finalizar seu cadastro, precisamos do seu telefone</p>
          </div>

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="telefone" className="form-label fw-medium">
                Telefone *
              </label>
              <input
                type="tel"
                id="telefone"
                className="form-control"
                value={telefone}
                onChange={handleTelefoneChange}
                placeholder="(11) 99999-9999"
                maxLength={15}
                required
                disabled={loading}
              />
              <div className="form-text">
                Digite seu telefone com DDD
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-success w-100"
              disabled={loading}
            >
              {loading ? (
                <>
                  <output className="spinner-border spinner-border-sm me-2"></output>
                  Salvando...
                </>
              ) : (
                'Finalizar Cadastro'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CompleteProfile;